export type ActionProps =
  | {
      type: "selectValue";
      parentKey: string;
      value: string;
      name: string;
      isInexperience?: boolean;
    }
  | { type: "unSelectValue"; parentKey: string; value: string }
  | { type: "unSelectParentValue"; parentKey: string };

export type selectedItemProps = Record<
  string,
  Record<
    string,
    {
      name: string;
      isInexperience?: boolean;
    }
  >
>;

export const initialState: selectedItemProps = {};

export const formStateReducer = (
  state: selectedItemProps,
  action: ActionProps,
): selectedItemProps => {
  switch (action.type) {
    case "selectValue":
      return {
        ...state,
        [action.parentKey]: {
          ...state[action.parentKey],
          [action.value]: {
            name: action.name,
            isInexperience: action.isInexperience,
          },
        },
      };
    case "unSelectValue": {
      const updatedParentKey = { ...state[action.parentKey] };
      delete updatedParentKey[action.value];

      if (Object.keys(updatedParentKey).length === 0) {
        const updatedUnSelectValueState = { ...state };
        delete updatedUnSelectValueState[action.parentKey];
        return updatedUnSelectValueState;
      }

      return {
        ...state,
        [action.parentKey]: updatedParentKey,
      };
    }
    case "unSelectParentValue": {
      const updatedUnSelectParentState = { ...state };
      delete updatedUnSelectParentState[action.parentKey];
      return updatedUnSelectParentState;
    }
    default:
      return state;
  }
};
